import UiPageList from "./UiPageList";
import DtoListItemOrderPoolProcessCount from "./DtoListItemOrderPoolProcessCount";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPageListOrderPoolProcessCount extends UiPageList<DtoListItemOrderPoolProcessCount, string> {
    constructor() {
        //无参构造函数
        super()
        this.PageIndex = 0;
        this.PageSize = 0;
        this.TotalCount = 0;
        this.TotalPages = 0;
        this.HasPrevPages = false;
        this.HasNextPages = false;
    }

    [proName: string]: any;
}

/**
 * -表单校验
 */
export const DtoPageListOrderPoolProcessCountRules = {
}
